import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/client/lib/api";

const listDeleted = () =>
  unwrap(api.deleted.$get()).then(({ items }) =>
    // Nothing edits a deleted row, so its deletion is its last change.
    items.map((item) => ({ ...item, updatedAt: item.deletedAt })),
  );

export type DeletedRow = Awaited<ReturnType<typeof listDeleted>>[number];

/** Filtered by kind in memory, so switching between All, Tasks and Projects is never a request. */
export const deletedQuery = queryOptions({
  queryKey: ["deleted"],
  queryFn: listDeleted,
  // The delta read does not carry deletions here, so a visit shows what is held and reads again.
  staleTime: 0,
});
